module.exports = __webpack_public_path__ + "static/DesignMaterialOne-5d2c25f64394e7d59e55ae275c4b8015.jpg";